<script>
import options from "./ProductInfo.options";
export default options;
</script>

<template>
    <article v-if="data" class="nti-product-info">
        <h1 class="nti-product-info__title">{{ data.title }}</h1>
        <div class="nti-product-info__container">
            <div class="nti-product-info__image-container">
                <img v-bind:src="data.imageUrl" alt="">
            </div>
            <button class="nti-product-info__scroll-to-configurator-button nti-button nti-button--confirm pardotTrackClick" @click="scrollToConfigurator">{{ verifyLabel('configuratorTitle') }}</button>
            <div v-html="data.description" class="nti-product-info__list"></div>
        </div>
    </article> 
</template>